export default __webpack_public_path__ + "static/about-us-will-ad3f466ad156f5a0f98917f8c8c6d915.webp";